import React from "react";
import { useNavigate } from "react-router-dom";
import Container from "@mui/material/Container";
import Alert from "@mui/material/Alert";
import Button from "@mui/material/Button";
import Box from "@mui/material/Box";
import CircularProgress from "@mui/material/CircularProgress";
import TableChartIcon from "@mui/icons-material/TableChart";

import { useChallengeTemplates } from "../../api/hooks/useChallenges";
import ChallengeTemplatesSection from "./components/ChallengeTemplatesSection";

import * as styles from "./ChallengesManagePage.module.scss";

const ChallengesManagePage: React.FC = () => {
  const navigate = useNavigate();
  const { data, isLoading, error } = useChallengeTemplates();

  if (isLoading && !data) {
    return (
      <Container maxWidth="xl">
        <div className={styles.container}>
          <Box sx={{ display: "flex", justifyContent: "center", py: 4 }}>
            <CircularProgress />
          </Box>
        </div>
      </Container>
    );
  }

  return (
    <Container maxWidth="xl">
      <div className={styles.container}>
        <Box className={styles.header}>
          <h1 className={styles.title}>Administra tus Retos</h1>
          <Button
            variant="outlined"
            startIcon={<TableChartIcon />}
            onClick={() => navigate("/challenges")}
          >
            Ver Tabla
          </Button>
        </Box>

        {error && (
          <Alert severity="error" className={styles.error} style={{ marginBottom: 24 }}>
            Error cargando retos: {error.message}
          </Alert>
        )}

        {data?.data && <ChallengeTemplatesSection templates={data.data} />}
      </div>
    </Container>
  );
};

export default ChallengesManagePage;
